// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"19":"2d279285770765aa","793":"2d279285770765aa","2888":"02118c897ed25f41","9728":"90af03815dbb08f7"}[chunkId] + ".css";
};